import React, { Component } from 'react';
import { observer, Provider } from 'mobx-react';
import { inject } from 'mobx-react/index';
import { Redirect, Route, Switch } from 'react-router';
import { GettingStartedStore } from './gettingstarted.store';
import { HomeDetailsProvider } from './homedetails/homedetails.provider';
import { FloorAreaProvider } from './floorarea/floorarea.provider';
import EmailLinkForm from '../_shared/emaillink/emaillink.form';

@inject('appStore')
@observer
export class GettingStartedProvider extends Component {
    gettingStartedStore;
    emailLinkForm;

    constructor(props) {
        super(props);
        const { appStore } = props;

        this.gettingStartedStore = new GettingStartedStore({
            appStore
        });

        this.emailLinkForm = new EmailLinkForm({
            store: props.appStore,
            appStore: props.appStore
        });
    }

    render() {
        return (
            <Provider
                gettingStartedStore={this.gettingStartedStore}
                emailLinkForm={this.emailLinkForm}
            >
                <Switch>
                    <Route
                        path='/gettingstarted/homedetails/:id?'
                        component={HomeDetailsProvider}
                    />
                    <Route
                        path='/gettingstarted/floorarea/:id?'
                        component={FloorAreaProvider}
                    />
                    <Route
                        path='/gettingstarted/:id?'
                        render={() => (
                            <Redirect
                                to='/gettingstarted/homedetails/'
                            />
                        )}
                    />
                    <Redirect to='/gettingstarted/homedetails' />
                </Switch>
            </Provider>
        );
    }
}
